import { render } from "./TablaAd.vue?vue&type=template&id=36b61751&scoped=true"
import script from "./TablaAd.vue?vue&type=script&lang=js"
export * from "./TablaAd.vue?vue&type=script&lang=js"

import "./TablaAd.vue?vue&type=style&index=0&id=36b61751&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b61751"]])

export default __exports__